export default "__VITE_ASSET__CiGKKtlq__"